import { enhancedApi as userApi } from '@ports/internal-services/user/userSlice';
import { enhancedApi as notificationSettingsApi } from '@ports/internal-services/notificationSettings/notificationSettingsSlice';
import { enhancedApi as paymentApi } from '@ports/internal-services/payment/paymentSlice';
import { enhancedApi as subscriptionApi } from '@ports/internal-services/subscription/subscriptionSlice';
import { enhancedApi as userAddressApi } from '@ports/internal-services/userAddress/userAddressSlice';
import { enhancedApi as userDetailsApi } from '@ports/internal-services/userDetails/userDetailsSlice';

export const apiSlices = [
  userApi,
  notificationSettingsApi,
  paymentApi,
  subscriptionApi,
  userAddressApi,
  userDetailsApi
];
